export const getActivityMerchandiseList = {
  url: '/admin/activity/getActivityMerchandiseList.json',
  method: 'get'
};
export const activityUpdate = {
  method: 'post',
  url: '/admin/activity/redPacket/insertOrUpdateActivityInfo.json'
};
export const getRedPacketList = {
  method: 'get',
  url: '/admin/activity/getActivityListByActivityType.json'
};
export const removeActivity = {
  method: 'post',
  url: '/admin/activity/deleteActivity.json',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};
export const endActivity = {
  method: 'post',
  url: '/admin/activity/earlyEndActivity.json',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};
export const getActivityInfo = {
  method: 'get',
  url: '/admin/activity/redPacket/getActivityInfoById.json'
};
export const getActivityWithdrawList = {
  method: 'get',
  url: '/admin/activity/redPacket/getActivityWithdrawRecordList.json'
};
export const exportActivityWithdrawList = {
  method: 'get',
  url: '/admin/activity/redPacket/exportActivityWithdrawRecordList.json'
};
export const activityBuygiveUpdate = {
  method: 'post',
  url: '/admin/activity/buyGive/insertOrUpdateActivityInfo.json'
};
export const getActivityBuygiveInfo = {
  method: 'get',
  url: '/admin/activity/buyGive/getActivityInfoById.json'
};

export const getActivityInfoByProdNo = {
  method: 'get',
  url: '/admin/activity/buyGive/getActivityInfoByProdNo.json'
};

export const getBranchInfoBySupplierId = {
  method: 'get',
  url: '/admin/activity/getBranchInfoListBySupplierId.json'
};

export const getVoteActivityList = {
  url: '/admin/activity/vote/pageList',
  method: 'get'
};

export const delVoteActivity = {
  url: '/admin/activity/deleteActivity.json',
  method: 'post'
};

export const saveVoteActivity = {
  url: '/admin/activity/vote/saveOrUpdate',
  method: 'post'
};

